<template>
  <v-list-group
    v-if="link.sublinks"
    id="#drawer-group"
    :model-value="link.text"
    color="#fff"
  >
    <template #activator="{ props }">
      <v-list-item
        v-bind="props"
        :title="link.text"
        :prepend-icon="link.icon"
        :append-icon="link.sublinks ? '$expand' : 'false'"
      />
    </template>

    <v-list-item
      v-for="sublink in link.sublinks"
      :key="sublink.text"
      :to="sublink.to"
      :link="true"
      :prepend-icon="sublink.icon"
    >
      <v-list-item-title v-text="sublink.text" />
    </v-list-item>
  </v-list-group>

  <v-list-item
    v-else
    :key="index"
    :to="link.to"
    :link="true"
    :prepend-icon="link.icon"
  >
    <v-list-item-title v-text="link.text" />
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "DrawerEntry",
  props: {
    link: Object,
    index: Number,
    selectedCustomer: Object,
    isLoggedIn: Boolean,
  },
});
</script>
